import { useCallback } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

export function useRovoHeroAnalytics() {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const firePlayPauseClicked = useCallback(
        (label: "play" | "pause") => {
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "playPause",
                source: "heroSection",
                attributes: { label }
            }).fire();
        },
        [createAnalyticsEvent]
    );

    const fireTeamSelected = useCallback(
        (team: string) => {
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "teamSelector",
                source: "heroSection",
                attributes: { team }
            }).fire();
        },
        [createAnalyticsEvent]
    );

    return { firePlayPauseClicked, fireTeamSelected };
}
